import React from 'react';

const SvgWaiting: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path d="M15.015 3.74a2.268 2.268 0 11-3.208 3.207 2.268 2.268 0 013.208-3.208M20.262 10.295a2.722 2.722 0 11-3.85 3.85 2.722 2.722 0 013.85-3.85M6.563 15.35a1.361 1.361 0 11-1.924 1.924 1.361 1.361 0 011.924-1.924M6.997 7.089a1.815 1.815 0 11-2.566 2.566A1.815 1.815 0 016.997 7.09" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.995 20.167a.453.453 0 10.002.906.453.453 0 00-.002-.906"
        />
      </g>
    </svg>
  );
};

export default SvgWaiting;
